<div class="documentation-fields content">
  <div class="card">
    <div class="documentation-fields_title">{{'CORE_DOCUMENTATION' | translate}}</div>
  </div>
  <div class="card">
    <div class="row">
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">BUTTONS</div>
        <div class="mb-2">
          <button class="si-button">Button</button>
        </div>
        <div class="mb-2">
          <button class="si-button_main si-button_big">Button main big</button>
        </div>
        <div class="mb-2">
          <button class="si-button_secondary">Button secondary</button>
        </div>
        <div>
          <button class="si-button_secondary-white">Button secondary-white</button>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">TRANSLATE</div>
        <div>
          <div>1: <span [translate]="translationText"></span></div>
          <div>2: <span translate="SI_HOME"></span></div>
          <div>3: <span>{{'SI_HOME' | translate}}</span></div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">TOOLTIP</div>
        <div>
          <span pTooltip="Tooltip right" tooltipPosition="right">Elemento con tooltip a la derecha</span>
        </div>
        <div>
          <span pTooltip="Tooltip top" tooltipPosition="top">Elemento con tooltip arriba</span>
        </div>
        <div>
          <span pTooltip="<div>Tooltip right</div><div>with line break</div>"
                tooltipPosition="right"
                [escape]="false">
            Elemento con tooltip a la derecha formateado con HTML
          </span>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">OVERLAY PANEL</div>
        <div class="d-flex align-items-center">
          <span class="mr-2">Clic en el icono:</span>
          <i class="icon-infocircle pointer"
             [attr.aria-label]="'CORE_OVERLAY_PANEL_OPEN' | translate"
             (click)="overlayPanel.toggle($event)"
          ></i>
          <si-overlay-panel #overlayPanel appendTo="body">
            <div>
              <div>
                <span>{{'SI_HOME' | translate}}: </span>
                <span class="bold">Result 1</span>
              </div>
              <div>
                <span>{{'SI_HOME' | translate}}: </span>
                <span class="bold">Result 2</span>
              </div>
              <div>
                <span>{{'SI_HOME' | translate}}: </span>
                <span class="bold">Result 3</span>
              </div>
            </div>
          </si-overlay-panel>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">CLICK OUTSIDE CLOSE</div>
        <div [(siClickOutsideClose)]="showClickOutside" siClickOutsideCloseButton="outsideCloseClass">
          <div class="mb-2">
            <div>
              <button class="si-button_secondary" (click)="onClickOutsideDirective()">
                Click para activar/desactivar
              </button>
              <div>(Click fuera para desactivar)</div>
            </div>
            <div>El elemento está activo: {{showClickOutside}}</div>
          </div>
          <div *ngIf="showClickOutside">
            Los elementos contenidos en el elemento con clickOutsideClose no activan la directiva.
          </div>
        </div>
        <div class="outsideCloseClass mt-3">
          Los elementos de fuera con X clase no activan la directiva.
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">DIALOG</div>
        <div class="mb-2">
          <button class="si-button_secondary" (click)="onClickOpenDialogSmall()">Abrir diálogo small</button>
        </div>
        <div>
          <button class="si-button_secondary" (click)="onClickOpenDialogMedium()">Abrir diálogo medium</button>
        </div>
        <ng-container *ngIf="displayDialogSmall">
          <p-dialog [(visible)]="displayDialogSmall"
                    [modal]="true"
                    [dismissableMask]="true"
                    appendTo="body"
                    styleClass="si-dialog-small">
            <div>
              <div class="d-flex">
                <div>
                  <i class="icon-nottoday alert-icon"></i>
                </div>
                <div>
                  <div class="bold mb-3">
                    <span translate="Título"></span>
                  </div>
                  <div>Contenido del diálogo</div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-4">
                <button class="si-button mr-2" (click)="onClickCloseDialog(false)">
                  {{'SI_CANCEL' | translate}}
                </button>
                <button class="si-button_main" (click)="onClickCloseDialog(true)">
                  {{'SI_ACCEPT' | translate}}
                </button>
              </div>
            </div>
          </p-dialog>
        </ng-container>
        <ng-container *ngIf="displayDialogMedium">
          <p-dialog [(visible)]="displayDialogMedium"
                    [modal]="true"
                    [dismissableMask]="true"
                    appendTo="body"
                    styleClass="si-dialog-medium">
            <div>
              <div class="d-flex">
                <div>
                  <i class="icon-nottoday alert-icon"></i>
                </div>
                <div>
                  <div class="bold mb-3">
                    <span translate="Título"></span>
                  </div>
                  <div>Contenido del diálogo</div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-4">
                <button class="si-button mr-2" (click)="onClickCloseDialog(false)">
                  {{'SI_CANCEL' | translate}}
                </button>
                <button class="si-button_main" (click)="onClickCloseDialog(true)">
                  {{'SI_ACCEPT' | translate}}
                </button>
              </div>
            </div>
          </p-dialog>
        </ng-container>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">MENU ICON</div>
        <div class="mb-2">
          <si-menu-icon tooltip="ABRIR MENÚ IZQUIERDA (DEFECTO)"
                        [menuItems]="tieredMenuItems"
          ></si-menu-icon>
        </div>
        <div class="d-flex justify-content-end mb-2">
          <si-menu-icon tooltip="ABRIR MENÚ DERECHA"
                        [menuItems]="tieredMenuItems"
                        tieredMenuStyles="tiered-menu_from-right tiered-menu_open-content-to-left"
          ></si-menu-icon>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">TIERED MENU</div>
        <div>
          <div class="mb-2">
            <div class="documentation-fields_tiered-menu">
              <button siPreventDoubleClick class="si-button_secondary" (click)="tieredMenu.toggle($event)">
                ABRIR MENÚ IZQUIERDA
              </button>
              <p-tieredMenu #tieredMenu [model]="tieredMenuItems" [popup]="true"
                            styleClass="tiered-menu_to-left tiered-menu_open-content-to-left"
              ></p-tieredMenu>
            </div>
          </div>
          <div class="mb-2">
            <span class="documentation-fields_tiered-menu">
              <button siPreventDoubleClick class="si-button_secondary" (click)="tieredMenu2.toggle($event)">
                ABRIR MENÚ DERECHA
              </button>
              <p-tieredMenu #tieredMenu2 [model]="tieredMenuItems" [popup]="true"
                            styleClass="tiered-menu_to-right"
              ></p-tieredMenu>
            </span>
          </div>
          <div class="mb-2">
            <span class="documentation-fields_tiered-menu">
              <button siPreventDoubleClick class="si-button_secondary" (click)="tieredMenu3.toggle($event)">
                ABRIR MENÚ DEBAJO IZQUIERDA (DEFECTO)
              </button>
              <p-tieredMenu #tieredMenu3 [model]="tieredMenuItems" [popup]="true"></p-tieredMenu>
            </span>
          </div>
          <div class="mb-2">
            <span class="documentation-fields_tiered-menu">
              <button siPreventDoubleClick class="si-button_secondary" (click)="tieredMenu4.toggle($event)">
                ABRIR MENÚ DEBAJO DERECHA
              </button>
              <p-tieredMenu #tieredMenu4 [model]="tieredMenuItems" [popup]="true"
                            styleClass="tiered-menu_from-right tiered-menu_open-content-to-left"
              ></p-tieredMenu>
            </span>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">TOAST</div>
        <div>
          <div class="mb-2">
            <button class="si-button_secondary" (click)="showToastSuccess()">Success</button>
          </div>
          <div class="mb-2">
            <button class="si-button_secondary" (click)="showToastError()">Error</button>
          </div>
          <div class="mb-2">
            <button class="si-button_secondary" (click)="showToastInfo()">Info</button>
          </div>
          <div>
            <button class="si-button_secondary" (click)="showToastWarning()">Warning</button>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">IR A OTRA RUTA</div>
        <div>
          <div class="d-flex mb-2">
            <div class="mr-2">Icono:</div>
            <si-go-to-route-icon [href]="['/']"
                                 icon="icon-home font-color-main1"
                                 tooltip="SI_HOME"
            ></si-go-to-route-icon>
          </div>
          <div class="d-flex">
            <div class="mr-2">Botón:</div>
            <si-go-to-route-button text="SI_HOME"
                                   [href]="['/']"
                                   styleClass="si-button_main"
            ></si-go-to-route-button>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">SCROLL ESTILIZADO</div>
        <div>
          <div class="documentation-fields_scroll_thin si-scroll-thin mb-2">
            <div>Texto de prueba</div>
            <div>Texto de prueba</div>
            <div>Texto de prueba</div>
            <div>Texto de prueba</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="row mb-3">
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">CAMPOS</div>
        <div>
          <button siPreventDoubleClick class="si-button_main mb-1" (click)="enableFields()">
            HABILITAR CAMPOS
          </button>
        </div>
        <div>
          <button siPreventDoubleClick class="si-button_secondary mb-1" (click)="enableFields(false)">
            DESHABILITAR CAMPOS
          </button>
        </div>
        <div>
          <button siPreventDoubleClick class="si-button_secondary-white" (click)="setReadMode(true)"
                  pTooltip="Cuando queramos el modo lectura, aparte de la clase 'readmode', los campos también deben llevar el atributo 'disabled'"
                  tooltipPosition="right">
            DESHABILITAR CAMPOS + MODO LECTURA
          </button>
        </div>
      </div>
    </div>

    <div class="row mb-3" [class.readmode]="readModeFlag">
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">INPUT</div>
        <div>
          <si-input id="inputExample"
                    name="inputExample"
                    text="Title"
                    placeholder="SI_WRITE_HERE"
                    tooltipText="Extra info"
                    [(model)]="inputModel"
                    [disabled]="disableFieldsFlag"
                    rule="generic.fieldNotNullLength"
          ></si-input>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">INPUT NUMBER</div>
        <div>
          <si-input id="inputNumberExample"
                    name="inputNumberExample"
                    text="Title"
                    placeholder="SI_WRITE_HERE"
                    tooltipText="Extra info"
                    type="number"
                    [(model)]="inputNumberModel"
                    [min]="1"
                    [max]="99"
                    [disabled]="disableFieldsFlag"
                    rule="numeric.minmax1-99"
          ></si-input>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">SWITCH</div>
        <div>
          <si-switch id="switchExample"
                     name="switchExample"
                     text="Title"
                     [(model)]="inputSwitchModel"
                     [disabled]="disableFieldsFlag"
                     [checked]="true"
          ></si-switch>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2"></div>
        <div>
        </div>
      </div>

      <div class="col-12 col-sm-6 mb-5">
        <div class="bold mb-2">MULTILINE</div>
        <div>
          <si-multiline id="multilineExample"
                        name="multilineExample"
                        text="Title"
                        placeholder="SI_WRITE_HERE"
                        [(model)]="multilineModel"
                        [rows]="4"
                        [disabled]="disableFieldsFlag"
                        rule="generic.fieldNotNullLength"
          ></si-multiline>
        </div>
      </div>

      <div class="col-12 col-sm-6 mb-5">
        <div class="bold mb-2">RICH TEXT</div>
        <div>
          <si-rich-text id="richTextExample"
                        name="richTextExample"
                        text="Title"
                        placeholder="SI_WRITE_HERE"
                        [(model)]="richTextModel"
                        [resize]="true"
                        [disabled]="disableFieldsFlag"
                        rule="generic.fieldNotNullLength"
          ></si-rich-text>
        </div>
      </div>

      <div class="w-100"></div>

      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">RADIO</div>
        <si-label text="Title" [disabled]="disableFieldsFlag"></si-label>
        <div>
          <si-radio id="radioExample"
                    name="radioExample"
                    text="Radio 1"
                    [(model)]="radioModel"
                    [value]="1"
                    [disabled]="disableFieldsFlag"
          ></si-radio>
          <si-radio id="radioExample2"
                    name="radioExample2"
                    text="Radio 2"
                    [(model)]="radioModel"
                    [value]="2"
                    [checked]="true"
                    [disabled]="disableFieldsFlag"
          ></si-radio>
          <si-radio id="radioExample3"
                    name="radioExample3"
                    text="Radio 3"
                    [(model)]="radioModel"
                    [value]="3"
                    [disabled]="disableFieldsFlag"
          ></si-radio>
          <div class="mt-2">Valor radio: {{radioModel}}</div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">RADIO DYNAMIC HORIZONTAL (DEFECTO)</div>
        <div>
          <si-radio-dynamic id="radioDynamicExample"
                            name="radioDynamicExample"
                            text="Title"
                            [(model)]="radioDynamicModel"
                            path="https://jsonplaceholder.typicode.com/users"
                            [disabled]="disableFieldsFlag"
          ></si-radio-dynamic>
          <div class="mt-2">
            <div>Salida: Objeto</div>
            <div>Valor (se muestra name del objeto): {{radioDynamicModel?.name}}</div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">RADIO DYNAMIC VERTICAL</div>
        <div>
          <si-radio-dynamic id="radioDynamicExample2"
                            name="radioDynamicExample2"
                            text="Title"
                            path="https://jsonplaceholder.typicode.com/users"
                            [(model)]="radioDynamicModel2"
                            valueAttr="id"
                            [vertical]="true"
                            [disabled]="disableFieldsFlag"
          ></si-radio-dynamic>
          <div class="mt-2">
            <div>Salida: Id</div>
            <div>Valor: {{radioDynamicModel2}}</div>
          </div>
        </div>
      </div>

      <div class="w-100"></div>

      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">RADIO BUTTON VERTICAL</div>
        <si-label text="Title" [disabled]="disableFieldsFlag"></si-label>
        <div class="si-radio-button-container_vertical">
          <si-radio-button id="radioButtonExample"
                           name="radioButtonExample"
                           text="Button 1"
                           [(model)]="radioButtonModel1"
                           [value]="1"
                           [disabled]="disableFieldsFlag"
          ></si-radio-button>
          <si-radio-button id="radioButtonExample2"
                           name="radioButtonExample2"
                           text="Button 2"
                           [(model)]="radioButtonModel1"
                           [value]="2"
                           [checked]="true"
                           [disabled]="disableFieldsFlag"
          ></si-radio-button>
          <si-radio-button id="radioButtonExample3"
                           name="radioButtonExample3"
                           text="Button 3"
                           [(model)]="radioButtonModel1"
                           [value]="3"
                           [disabled]="disableFieldsFlag"
          ></si-radio-button>
        </div>
        <div class="mt-2">Valor radioButton: {{radioButtonModel1}}</div>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">RADIO BUTTON HORIZONTAL</div>
        <si-label text="Title" [disabled]="disableFieldsFlag"></si-label>
        <div class="col-12 row no-gutters si-radio-button-container_horizontal">
          <si-radio-button id="radioButtonExampleH"
                           name="radioButtonExampleH"
                           text="Button 1"
                           [(model)]="radioButtonModel2"
                           [value]="1"
                           [disabled]="disableFieldsFlag"
          ></si-radio-button>
          <si-radio-button id="radioButtonExampleH2"
                           name="radioButtonExampleH2"
                           text="Button 2"
                           [(model)]="radioButtonModel2"
                           [value]="2"
                           [checked]="true"
                           [disabled]="disableFieldsFlag"
          ></si-radio-button>
          <si-radio-button id="radioButtonExampleH3"
                           name="radioButtonExampleH3"
                           text="Button 3"
                           [(model)]="radioButtonModel2"
                           [value]="3"
                           [disabled]="disableFieldsFlag"
          ></si-radio-button>
        </div>
        <div class="mt-2">Valor radioButton: {{radioButtonModel2}}</div>
      </div>

      <div class="w-100"></div>

      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">CHECK</div>
        <div>
          <si-check id="checkExample"
                    name="checkExample"
                    text="SI_HOME"
                    [(model)]="checkModel"
                    [disabled]="disableFieldsFlag"
                    [checked]="true"
          ></si-check>
          <div class="mt-2">Valor check: {{checkModel}}</div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">CHECK DYNAMIC CON VALUES (HORIZONTAL)</div>
        <div>
          <si-check-dynamic id="checkDynamicExample"
                            name="checkDynamicExample"
                            text="Title"
                            [(model)]="checkDynamicModel"
                            [values]="selectorValues"
                            valueAttr="id"
                            [disabled]="disableFieldsFlag"
          ></si-check-dynamic>
          <div class="mt-2">
            <div class="bold">Ejemplo con valueAttr</div>
            <div>Entrada: Id[]</div>
            <div>Salida: Id[]</div>
            <div>Valor seleccionado: {{checkDynamicModel?.toString()}}</div>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">CHECK DYNAMIC CON PATH (VERTICAL)</div>
        <div>
          <si-check-dynamic id="checkDynamicPathExample"
                            name="checkDynamicPathExample"
                            text="Title"
                            [(model)]="checkDynamicPathModel"
                            path="https://jsonplaceholder.typicode.com/users"
                            [vertical]="true"
                            [disabled]="disableFieldsFlag"
          ></si-check-dynamic>
          <div class="mt-2">
            <div>Entrada: Objeto[]</div>
            <div>Salida: Objeto[]</div>
            <div>Valor seleccionado: {{checkDynamicPathModel?.toString()}}</div>
          </div>
        </div>
      </div>

      <div class="w-100"></div>

      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">DATEPICKER FROM (SOLO FECHA)</div>
        <div>
          <si-datepicker id="datepickerFromExample"
                         name="datepickerFromExample"
                         text="CORE_START_DATE"
                         placeholder="CORE_DATEPICKER_L"
                         [(model)]="datepickerFromModel"
                         [maxDate]="datepickerToModel"
                         startOf="day"
                         [onlyFuture]="true"
                         [disabled]="disableFieldsFlag"
                         rule="generic.fieldNotNull"
          ></si-datepicker>
        </div>
        <div class="mt-2">Valor datepicker: {{datepickerFromModel}}</div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">DATEPICKER TO (FECHA Y HORA)</div>
        <div>
          <si-datepicker id="datepickerToExample"
                         name="datepickerToExample"
                         text="CORE_END_DATE"
                         placeholder="CORE_DATEPICKER_L_LT"
                         format="L LT"
                         [(model)]="datepickerToModel"
                         [minDate]="datepickerFromModel"
                         [showTime]="true"
                         endOf="day"
                         [empty]="true"
                         [disabled]="disableFieldsFlag"
          ></si-datepicker>
        </div>
        <div class="mt-2">Valor datepicker: {{datepickerToModel}}</div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">DATEPICKER (SOLO HORA)</div>
        <div>
          <si-datepicker id="datepickerTimeExample"
                         name="datepickerTimeExample"
                         text="Hora"
                         placeholder="CORE_DATEPICKER_LT"
                         format="LT"
                         [timeOnly]="true"
                         [(model)]="datepickerTimeModel"
                         [disabled]="disableFieldsFlag"
          ></si-datepicker>
        </div>
        <div class="mt-2">Valor datepicker: {{datepickerTimeModel}}</div>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2"></div>
        <div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">SELECTOR CON VALUES</div>
        <div>
          <si-selector id="selectorValuesExample"
                       name="selectorValuesExample"
                       text="Title"
                       placeholder="SI_SELECT_PLACEHOLDER"
                       [(model)]="selectorValuesModel"
                       [values]="selectorValues"
                       [disabled]="disableFieldsFlag"
                       rule="generic.fieldNotNull"
          ></si-selector>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">SELECTOR CON VALOR POR DEFECTO (code)</div>
        <div>
          <si-selector id="selectorInputExample"
                       name="selectorInputExample"
                       text="Title"
                       placeholder="SI_SELECT_PLACEHOLDER"
                       [(model)]="selectorInput"
                       [values]="selectorValues"
                       valueAttrInput="code"
                       [disabled]="disableFieldsFlag"
                       rule="generic.fieldNotNull"
          ></si-selector>
          <div>
            <div>Entrada: atributo code (string)</div>
            <div>Salida: objeto completo (IdName)</div>
            <div>Valor seleccionado: {{selectorInput}}</div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">SELECTOR CON VALOR DE SALIDA DE ATRIBUTO (code)</div>
        <div>
          <si-selector id="selectorOutputExample"
                       name="selectorOutputExample"
                       text="Title"
                       placeholder="SI_SELECT_PLACEHOLDER"
                       [(model)]="selectorOutput"
                       [values]="selectorValues"
                       valueAttr="code"
                       [disabled]="disableFieldsFlag"
                       rule="generic.fieldNotNull"
          ></si-selector>
          <div>
            <div>Entrada: -</div>
            <div>Salida: atributo code (number)</div>
            <div>Valor seleccionado: {{selectorOutput}}</div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">SELECTOR CON VALOR POR DEFECTO (code) Y VALOR DE SALIDA DE ATRIBUTO (id)</div>
        <div>
          <si-selector id="selectorInputOutputExample"
                       name="selectorInputOutputExample"
                       text="Title"
                       placeholder="SI_SELECT_PLACEHOLDER"
                       [(model)]="selectorInputOutput"
                       [values]="selectorValues"
                       valueAttrInput="code"
                       valueAttr="id"
                       [disabled]="disableFieldsFlag"
                       rule="generic.fieldNotNull"
          ></si-selector>
          <div>
            <div>Entrada: atributo code (string)</div>
            <div>Salida: atributo id (number)</div>
            <div>Valor seleccionado: {{selectorInputOutput}}</div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">SELECTOR CON PATH SIN BACKSEARCH</div>
        <div>
          <si-selector id="selectorExample"
                       name="selectorExample"
                       text="Title"
                       placeholder="SI_SELECT_PLACEHOLDER"
                       [(model)]="selectorModel"
                       path="https://jsonplaceholder.typicode.com/users"
                       [disabled]="disableFieldsFlag"
                       rule="generic.fieldNotNull"
          ></si-selector>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">SELECTOR CON PATH Y BACKSEARCH</div>
        <div>
          <si-selector id="selectorBackSearchExample"
                       name="selectorBackSearchExample"
                       text="Title"
                       placeholder="SI_SELECT_PLACEHOLDER"
                       [(model)]="selectorBackSearchModel"
                       path="https://jsonplaceholder.typicode.com/users"
                       [disabled]="disableFieldsFlag"
                       rule="generic.fieldNotNull"
                       backSearch
          ></si-selector>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">SELECTOR CON PLANTILLA PERSONALIZADA</div>
        <div>
          <si-selector id="selectorTemplateExample"
                       name="selectorTemplateExample"
                       text="Title"
                       placeholder="SI_SELECT_PLACEHOLDER"
                       [(model)]="selectorTemplateModel"
                       path="https://jsonplaceholder.typicode.com/users"
                       [disabled]="disableFieldsFlag"
                       rule="generic.fieldNotNull">
            <ng-template #selectedItem let-item>
              <div class="d-flex">
                <div>
                  <span>{{item.label}}</span>
                </div>
                <div class="ml-auto">
                  <span>({{item.value.username}})</span>
                </div>
              </div>
            </ng-template>
            <ng-template #item let-item>
              <div class="d-flex">
                <div>
                  <span>{{item.label}}</span>
                </div>
                <div class="ml-auto">
                  <span>({{item.value.username}})</span>
                </div>
              </div>
            </ng-template>
          </si-selector>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">SELECTOR CON BOTONES</div>
        <div>(solo versión movil)</div>
        <div>
          <si-selector id="selectorWithButtons"
                       name="selectorWithButtons"
                       text="Title"
                       placeholder="SI_SELECT_PLACEHOLDER"
                       [(model)]="selectorWithButtonsModel"
                       path="https://jsonplaceholder.typicode.com/users"
                       [showDropdownButtons]="true"
                       [disabled]="disableFieldsFlag"
                       rule="generic.fieldNotNull"
          ></si-selector>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">SELECTOR SIN BUSCADOR</div>
        <div>
          <si-selector id="selectorWithoutSearch"
                       name="selectorWithoutSearch"
                       text="Title"
                       placeholder="SI_SELECT_PLACEHOLDER"
                       [(model)]="selectorWithoutSearchModel"
                       path="https://jsonplaceholder.typicode.com/users"
                       [showDropdownSearch]="false"
                       [disabled]="disableFieldsFlag"
                       rule="generic.fieldNotNull"
          ></si-selector>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">SELECTOR PERSONALIZADO</div>
        <div>
          <si-selector-custom text="Title"
                              [values]="selectorValues"
                              [disabled]="disableFieldsFlag">
            <button class="si-button_main w-100">{{'Title' | translate}}</button>
          </si-selector-custom>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">SELECTOR PERSONALIZADO CON PLANTILLA PERSONALIZADA</div>
        <div>
          <si-selector-custom text="Title"
                              [values]="selectorValues"
                              [disabled]="disableFieldsFlag">
            <ng-template #selectedItemCustom let-item>
              <button class="si-button_main w-100">{{'Title' | translate}}</button>
            </ng-template>
            <ng-template #itemCustom let-item>
              <div class="d-flex">
                <div>
                  <span>{{item.value.name}}</span>
                </div>
                <div class="ml-auto">
                  <span>({{item.value.code}})</span>
                </div>
              </div>
            </ng-template>
          </si-selector-custom>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 mb-5">
      </div>

      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">SELECTOR MÚLTIPLE CON VALUES</div>
        <div>
          <si-selector-multiple id="selectorMultipleValuesExample"
                                name="selectorMultipleValuesExample"
                                text="Title"
                                placeholder="SI_SELECT_PLACEHOLDER"
                                [(model)]="selectorMultipleValuesModel"
                                [values]="selectorValues"
                                [disabled]="disableFieldsFlag"
                                rule="generic.fieldNotNull"
          ></si-selector-multiple>
          <div class="mt-2">
            <div class="bold">Ejemplo con valueAttr</div>
            <div>Entrada: Objeto[]</div>
            <div>Salida: Id[]</div>
            <div>
              <span>Valor:&nbsp;-</span>
              <span *ngFor="let item of selectorMultipleValuesModel">
                {{item}} -
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">SELECTOR MÚLTIPLE CON VALOR POR DEFECTO (code)</div>
        <div>
          <si-selector-multiple id="selectorMultipleInputExample"
                                name="selectorMultipleInputExample"
                                text="Title"
                                placeholder="SI_SELECT_PLACEHOLDER"
                                [(model)]="selectorMultipleInput"
                                [values]="selectorValues"
                                valueAttrInput="code"
                                [disabled]="disableFieldsFlag"
                                rule="generic.fieldNotNull"
          ></si-selector-multiple>
          <div>
            <div>Entrada: atributo code (string[])</div>
            <div>Salida: objeto completo (IdName[])</div>
            <div>Valor seleccionado: {{selectorMultipleInput}}</div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">SELECTOR MÚLTIPLE CON VALOR DE SALIDA DE ATRIBUTO (code)</div>
        <div>
          <si-selector-multiple id="selectorMultipleOutputExample"
                                name="selectorMultipleOutputExample"
                                text="Title"
                                placeholder="SI_SELECT_PLACEHOLDER"
                                [(model)]="selectorMultipleOutput"
                                [values]="selectorValues"
                                valueAttr="code"
                                [disabled]="disableFieldsFlag"
                                rule="generic.fieldNotNull"
          ></si-selector-multiple>
          <div>
            <div>Entrada: -</div>
            <div>Salida: atributo code (string[])</div>
            <div>Valor seleccionado: {{selectorMultipleOutput}}</div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">SELECTOR MÚLTIPLE CON VALOR POR DEFECTO (code) Y VALOR DE SALIDA DE ATRIBUTO (id)</div>
        <div>
          <si-selector-multiple id="selectorMultipleInputOutputExample"
                                name="selectorMultipleInputOutputExample"
                                text="Title"
                                placeholder="SI_SELECT_PLACEHOLDER"
                                [(model)]="selectorMultipleInputOutput"
                                [values]="selectorValues"
                                valueAttrInput="code"
                                valueAttr="id"
                                [disabled]="disableFieldsFlag"
                                rule="generic.fieldNotNull"
          ></si-selector-multiple>
          <div>
            <div>Entrada: atributo code (string[])</div>
            <div>Salida: atributo id (number[])</div>
            <div>Valor seleccionado: {{selectorMultipleInputOutput}}</div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">SELECTOR MÚLTIPLE CON PATH SIN BACKSEARCH</div>
        <div>
          <si-selector-multiple id="selectorMultipleExample"
                                name="selectorMultipleExample"
                                text="Title"
                                placeholder="SI_SELECT_PLACEHOLDER"
                                [(model)]="selectorMultipleModel"
                                path="https://jsonplaceholder.typicode.com/users"
                                [disabled]="disableFieldsFlag"
                                rule="generic.fieldNotNull"
          ></si-selector-multiple>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">SELECTOR MÚLTIPLE CON PATH Y BACKSEARCH</div>
        <div>
          <si-selector-multiple id="selectorMultipleBackSearchExample"
                                name="selectorMultipleBackSearchExample"
                                text="Title"
                                placeholder="SI_SELECT_PLACEHOLDER"
                                [(model)]="selectorMultipleBackSearchModel"
                                path="https://jsonplaceholder.typicode.com/users"
                                [disabled]="disableFieldsFlag"
                                rule="generic.fieldNotNull"
                                backSearch
          ></si-selector-multiple>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">SELECTOR MÚLTIPLE CON PLANTILLA PERSONALIZADA</div>
        <div>
          <si-selector-multiple id="selectorMultipleTemplateExample"
                                name="selectorMultipleTemplateExample"
                                text="Title"
                                placeholder="SI_SELECT_PLACEHOLDER"
                                [(model)]="selectorMultipleTemplateModel"
                                path="https://jsonplaceholder.typicode.com/users"
                                [disabled]="disableFieldsFlag"
                                rule="generic.fieldNotNull">
            <ng-template #selectedItems let-items>
              <ng-container *ngIf="!items?.length">{{'SI_SELECT_PLACEHOLDER' | translate}}</ng-container>
              <span *ngFor="let item of items; let last = last">
                <span>{{item.name}} ({{item.username}})</span>
                <span *ngIf="!last">, </span>
              </span>
            </ng-template>
            <ng-template #item let-item>
              <div class="d-flex flex-grow-1">
                <div>
                  <span>{{item.label}}</span>
                </div>
                <div class="ml-auto">
                  <span>({{item.value.username}})</span>
                </div>
              </div>
            </ng-template>
          </si-selector-multiple>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">SELECTOR DIALOG</div>
        <div>
          <si-selector-dialog id="selectorDialogExample"
                              name="selectorDialogExample"
                              text="Title"
                              placeholder="SI_SELECT_PLACEHOLDER"
                              [(model)]="selectorDialogModel"
                              [(displayDialog)]="displaySelectorDialog"
                              (displayDialogChange)="onDisplaySelectorDialog($event)"
                              [disabled]="disableFieldsFlag"
                              rule="generic.fieldNotNull">
            <ng-container *ngIf="displaySelectorDialog">
              <p-dialog [(visible)]="displaySelectorDialog"
                        [modal]="true"
                        [dismissableMask]="true"
                        appendTo="body"
                        styleClass="si-dialog-medium">
                <div>
                  <div class="d-flex">
                    <div>
                      <i class="icon-infocircle info-icon"></i>
                    </div>
                    <div class="flex-grow-1">
                      <div class="bold mb-3">
                        <span translate="Título"></span>
                      </div>
                      <div class="row mb-3" [class.readmode]="readModeFlag">
                        <div class="col-12 col-sm-6">
                          <si-selector id="selectorDialogSelectorExample"
                                       name="selectorDialogSelectorExample"
                                       text="Title"
                                       placeholder="SI_SELECT_PLACEHOLDER"
                                       [(model)]="selectorDialogInternalModel1"
                                       [values]="selectorValues"
                                       rule="generic.fieldNotNull"
                          ></si-selector>
                        </div>
                        <div class="col-12 col-sm-6">
                          <si-selector id="selectorDialogSelectorExample2"
                                       name="selectorDialogSelectorExample2"
                                       text="Title"
                                       placeholder="SI_SELECT_PLACEHOLDER"
                                       [(model)]="selectorDialogInternalModel2"
                                       [disabled]="!selectorDialogInternalModel1"
                                       [values]="selectorValues"
                                       rule="generic.fieldNotNull"
                          ></si-selector>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end mt-4">
                    <button class="si-button mr-2" (click)="onClickCloseSelectorDialog(false)">
                      {{'SI_CANCEL' | translate}}
                    </button>
                    <button class="si-button_main" (click)="onClickCloseSelectorDialog(true)">
                      {{'SI_ACCEPT' | translate}}
                    </button>
                  </div>
                </div>
              </p-dialog>
            </ng-container>
          </si-selector-dialog>
        </div>
      </div>
      <div class="col-12 mb-5">
        <div class="bold mb-2">SELECTOR MÚLTIPLE DETAIL MODE</div>
        <div>
          <si-selector-multiple #siSelectorMultipleDetail
                                id="selectorMultipleDetailExample"
                                name="selectorMultipleDetailExample"
                                text="Title"
                                placeholder="SI_SELECT_PLACEHOLDER"
                                [(model)]="selectorMultipleDetailModel"
                                path="https://jsonplaceholder.typicode.com/users"
                                rule="generic.fieldNotNull"
                                [disabled]="disableFieldsFlag"
                                [detailMode]="true">
            <ng-template #selectedItems let-items>
              <ng-container *ngIf="!items?.length">{{'SI_SELECT_PLACEHOLDER' | translate}}</ng-container>
              <span *ngFor="let item of items; let last = last" class="si-selector-multiple_chip">
                <span>{{item.name}}</span>
                <span (click)="siSelectorMultipleDetail.removeOption($event, item)"
                      class="si-selector-multiple_chip_remove">
                  <i class="icon-closex"></i>
                </span>
              </span>
            </ng-template>
          </si-selector-multiple>
        </div>
        <div class="d-flex mt-2" *ngIf="!readModeFlag">
          <div class="ml-auto mr-2">
            <button siPreventDoubleClick
                    type="button"
                    class="si-button"
                    (click)="siSelectorMultipleDetail.openMultiSelect($event)"
                    [disabled]="disableFieldsFlag">
              <span>{{'CORE_ADD' | translate}}</span>
            </button>
          </div>
          <div>
            <button siPreventDoubleClick
                    type="button"
                    class="si-button_secondary"
                    (click)="siSelectorMultipleDetail.removeOptions()"
                    [disabled]="disableFieldsFlag">
              {{'SI_CLEAR' | translate}}
            </button>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">FILE UPLOAD (SOLO IMÁGENES)</div>
        <div>
          <si-file-upload id="fileUploadExample"
                          name="fileUploadExample"
                          text="Title"
                          [(model)]="uploadedFiles"
                          accept="image/*"
                          [disabled]="disableFieldsFlag"
                          rule="generic.fieldNotNull"
          ></si-file-upload>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">FILE UPLOAD MÚLTIPLE</div>
        <div>
          <si-file-upload id="fileUploadMultipleExample"
                          name="fileUploadMultipleExample"
                          text="Title"
                          [(model)]="uploadedFilesMultiple"
                          [multiple]="true"
                          [fileLimit]="3"
                          [disabled]="disableFieldsFlag"
                          rule="generic.fieldNotNull"
          ></si-file-upload>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">FILE UPLOAD MÚLTIPLE (CON DOCUMENTOS YA CARGADOS)</div>
        <div>
          <si-file-upload id="fileUploadMultipleWithFilesExample"
                          name="fileUploadMultipleWithFilesExample"
                          text="Title"
                          [(model)]="uploadedFilesMultipleWithFiles"
                          path=""
                          [multiple]="true"
                          [disabled]="disableFieldsFlag"
                          rule="generic.fieldNotNull"
          ></si-file-upload>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 mb-5">
        <div class="bold mb-2">FILE UPLOAD MÚLTIPLE (MAQUETACIÓN CON IMAGEN)</div>
        <div>
          <si-file-upload id="fileUploadMultipleExample"
                          name="fileUploadMultipleExample"
                          text="Title"
                          subtext="Subtítulo de ejemplo"
                          image="assets/images/upload-ok.svg"
                          imageError="assets/images/upload-error.svg"
                          [(model)]="uploadedFilesMultiple"
                          accept="application/pdf,image/*"
                          [multiple]="true"
                          [fileLimit]="3"
                          [disabled]="disableFieldsFlag"
                          rule="generic.fieldNotNull"
          ></si-file-upload>
        </div>
      </div>
    </div>
  </div>
</div>
